<style scope>
  .fonte_11 {
    font-size: 11px
  }
</style>

<template>
  <div>

      <b-table :data="lista" :loading="loading" class="row-click fonte_11"
               :paginated="true" :perPage="20" :default-sort-direction="'desc'"
               default-sort="DATA_CADASTRO">
        <portal-lista-vazia slot="empty"/>

        <template slot-scope="props">

          <b-table-column label="CNPJ">
            {{ props.row.CNPJ | cpfcnpj }}
          </b-table-column>

          <b-table-column label="RAZÃO SOCIAL" field="RAZAO" sortable>
            <b-tooltip :label="props.row.FANTASIA">
              {{ props.row.RAZAO }}
            </b-tooltip>
          </b-table-column>

          <b-table-column label="Endereço">
          {{ props.row.ENDERECO }}
          </b-table-column>

          <b-table-column label="Bairro" field="BAIRRO" sortable>
            {{ props.row.BAIRRO }}
          </b-table-column>

          <b-table-column label="Cidade" field="CIDADE" sortable>
            {{ props.row.CIDADE }}
          </b-table-column>

          <b-table-column label="UF">
            {{ props.row.ESTADO }}
          </b-table-column>

          <b-table-column label="Data do Cadastro" field="DATA_CADASTRO"  sortable>
            {{ props.row.DATA_CADASTRO |moment('DD/MM/YYYY') }}
          </b-table-column>
          
          <b-table-column label="Status">
            <b-tag type="is-danger" v-if="props.row.TRANSFERIDO === 'N'">Sincronizando...</b-tag>
            <b-tag type="is-info" v-if="props.row.TRANSFERIDO === 'S'" >Sincronizado</b-tag>
            <b-tag type="is-success" v-if="props.row.TRANSFERIDO === 'P'" >Processado</b-tag>
          </b-table-column>

           <b-table-column label="Dowload" :visible="true">
            <button class="button is-small" @click="downloadProspect(props.row.CNPJ)"
                    title="Download">
                <b-icon icon="file-pdf"/>
            </button>
          </b-table-column>

        </template>

      </b-table>

  </div>
</template>

<script>
  export default {
    props: ['lista', 'loading', 'parametros'],
    methods: {
      downloadProspect (cnpj) {
        this.isLoading = true
        this.$http({
          method: 'get',
          url: this.$URL.DOWNLOAD.CNPJ + cnpj,
          responseType: 'arraybuffer'
        })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'PROSPECT_' + cnpj + '.pdf')
            document.body.appendChild(link)
            link.click()
            this.isLoading = false
          })
          .catch((response) => {
            this.$toast.open({
              message: 'Não foi possível localizar o prospect para download.',
              type: 'is-danger',
              duration: 4 * 1000
            })
            this.isLoading = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/cliente/ListaProspecto.vue